import styled from 'styled-components';
import { font } from '../globals/fonts';

export var Header = styled.h1.withConfig({ displayName: "Headerstyle__Header", componentId: "sc-1mu85bz-0" })(["font-family:", ";text-align:center;"],
font.light);
//# sourceMappingURL=Header.style.js.map